import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { ConfirmDialogResponse } from "~app/common/models/constants";

@Component({
    selector: "rask-return-atgard-to-giss-popup",
    templateUrl: "./return-atgard-to-giss-popup.component.html",
    styleUrls: ["./return-atgard-to-giss-popup.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextareaComponent,
        FormsModule,
        ButtonComponent,
        TranslatePipe
    ]
})
export class ReturnAtgardToGissPopupComponent {
    modal = inject(NgbActiveModal);

    @Input()
    get data(): string {
        return this._data;
    }
    set data(value: string) {
        this._data = value;
    }
    _data: string;

    protected returnera(): void {
        this.modal.close(this._data);
    }

    protected cancel(): void {
        this.modal.close(ConfirmDialogResponse.cancel);
    }
}
